import { combineReducers } from "redux";
import uploadVid from "./reducer";
import progReducer from './progReducer';
import uploadAud from './audioReducer';
import progReducerAudio from './progReducerAudio';
import searchFilterReducer from './searchFilterReducer'
import updateBookmark from './bookmarkReducer'
import configSet from './configReducer'
import updateReduxStore from './contextReducer'

const rootReducer = combineReducers({
    uploadVid,
    progReducer,
    uploadAud,
    progReducerAudio,
    searchFilterReducer,
    updateBookmark,
    configSet,
    updateReduxStore,
});

export default rootReducer;